document.addEventListener("DOMContentLoaded", () => {
    const lines = document.querySelectorAll('.hp-timeline__progress-item');
    const stickyElement = document.querySelector('.hp-timeline__media');
    const stickyHeight = stickyElement.offsetHeight;
    const timeline = gsap.timeline();
  
    gsap.registerPlugin(ScrollTrigger)
    stickyElement.style.setProperty('--sticky-height', `${stickyHeight}px`);
  
    lines.forEach((line, index) => {
      timeline.to(line, {
        "--timeline-height": index === lines.length - 1 ? "initial" : "100%",
        scrollTrigger: {
          trigger: line,
          start: 'top center',
          end: index === lines.length - 1 ? 'bottom bottom' : 'bottom center',
          scrub: true,
          onEnter: () => gsap.to(line, { opacity: 1, duration: 0.5 }),
          onLeaveBack: () => gsap.to(line, { opacity: 0, duration: 0.5 })
        }
      });
    });
  });
  